import * as React from "react"
import { Dialog, FlatButton, FontIcon } from "material-ui"
import strings from "../../../localization/strings"
import { IEmployeeAccrualAudit } from "../../../models"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import moment from "moment"
import { CSVLink } from "react-csv"

interface IProps {
	employeeName: string
	accrualName: string
	audits: IEmployeeAccrualAudit[]
	handleClose(): void
}
const styles = {
	nameCol: {
		cursor: "pointer",
		paddingLeft: 5,
		paddingRight: 5,
		width: 80,
	},
	dateCol: {
		cursor: "pointer",
		paddingLeft: 5,
		paddingRight: 5,
		width: 115,
	},
	noteCol: {
		cursor: "pointer",
		paddingLeft: 5,
		paddingRight: 5,
		whiteSpace: "normal",
		wordWrap: "break-word",
	},
	numberCol: {
		cursor: "pointer",
		paddingLeft: 2,
		paddingRight: 2,
		width: 85,
		textAlign: "center"
	},
}

const UserAccrualAuditDialog: React.SFC<IProps> = (props: IProps) => {
	const downloadData = [
		[
			strings.Name,
			strings.Date,
			strings.Note,
			strings.Accrual_Used,
			strings.Accrual_Earned
		]
	]

	props.audits.forEach(audit => {
		downloadData.push(
			[
				audit.NameOfChangingUser,
				moment(audit.DateTimeOfChange).format("YYYY-MM-DD HH:mm"),
				audit.ChangeNote,
				audit.DiffBalance < 0 ? (-audit.DiffBalance).toString() : "",
				audit.DiffBalance > 0 ? (audit.DiffBalance).toString() : ""
			]
		)
	})

	return (
		<Dialog
			open
			title={
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<div>{strings.Employee_Accrual_Changing_Information}</div>

					<CSVLink
						key="csvlink"
						data={downloadData}
						filename={`Employee(${props.employeeName})'s_Accrual(${props.accrualName})_Audits_Report_${moment().format("YYYY-MM-DD")}.csv`}
					>
						<FontIcon className="fa fa-download" />
					</CSVLink>
				</div>
			}
			titleStyle={{ paddingLeft: 50, paddingRight: 50, paddingBottom: 10 }}
			actions={
				<FlatButton
					label={strings.OK}
					primary={true}
					onTouchTap={props.handleClose}
				/>
			}
		>
			<Table multiSelectable={false} selectable={false}
				bodyStyle={{
					maxHeight: "400",
					overflowY: "visible"
				}}
			>
				<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
					<TableRow>
						<TableHeaderColumn style={styles.nameCol}>{strings.Name}</TableHeaderColumn>
						<TableHeaderColumn style={styles.dateCol}>{strings.Date}</TableHeaderColumn>
						<TableHeaderColumn style={styles.noteCol}>{strings.Note}</TableHeaderColumn>
						<TableHeaderColumn style={styles.numberCol} className="TextOverflow" title={strings.Accrual_Used}>{strings.Accrual_Used}</TableHeaderColumn>
						<TableHeaderColumn style={styles.numberCol} className="TextOverflow" title={strings.Accrual_Earned}>{strings.Accrual_Earned}</TableHeaderColumn>
					</TableRow>
				</TableHeader>
				<TableBody showRowHover={false} deselectOnClickaway={true} stripedRows={true} displayRowCheckbox={false}>
					{props.audits.map((row, i) => {
						const usedValue = row.DiffBalance < 0 ? -row.DiffBalance : ""
						const earnedValue = row.DiffBalance > 0 ? row.DiffBalance : ""
						return (
							<TableRow key={`row-${i}`}>
								<TableRowColumn style={styles.nameCol} title={row.NameOfChangingUser}>{row.NameOfChangingUser}</TableRowColumn>
								<TableRowColumn style={styles.dateCol}>{moment(row.DateTimeOfChange).format("YYYY-MM-DD HH:mm")}</TableRowColumn>
								<TableRowColumn style={styles.noteCol}>{row.ChangeNote}</TableRowColumn>
								<TableRowColumn style={styles.numberCol}>{usedValue}</TableRowColumn>
								<TableRowColumn style={styles.numberCol}>{earnedValue}</TableRowColumn>
							</TableRow>
						)
					})}
				</TableBody>
			</Table>
		</Dialog>
	)
}

export default UserAccrualAuditDialog